/**
 * LoadingStore — Pinia store quản lý trạng thái loading toàn trang
 * Dùng boolean loading để bật/tắt v-loading directive của MISA UI Control
 * Tích hợp với App.vue qua getter isLoading
 * CreatedBy: dbhuan (14/06/2026)
 * UpdatedBy: dbhuan (14/06/2026) — thay counter bang boolean loading
 */
import { defineStore } from "pinia";

export const useLoadingStore = defineStore("loading", {
  state: () => ({
    /** Trạng thái loading — true = đang hiển thị overlay */
    loading: false,
    /** Tiêu đề chính — hiển thị khi type=vertical */
    title: "",
    /** Tiêu đề phụ — hiển thị khi type=vertical */
    subtitle: "",
  }),

  getters: {
    /** Đang loading — bind vào v-loading directive */
    isLoading: (state) => state.loading,
    /** Title cho v-loading directive */
    loadingTitle: (state) => state.title,
    /** Subtitle cho v-loading directive */
    loadingSubtitle: (state) => state.subtitle,
  },

  actions: {
    /**
     * Hiển thị loading overlay.
     * @param {string} [title=""] - Tiêu đề chính
     * @param {string} [subtitle=""] - Tiêu đề phụ
     */
    show(title = "", subtitle = "") {
      this.loading = true;
      this.title = title;
      this.subtitle = subtitle;
    },

    /** Ẩn loading overlay. */
    hide() {
      this.loading = false;
      this.title = "";
      this.subtitle = "";
    },
  },
});
